import {
    SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_BEGIN,
    SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_SUCCESS,
    SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_FAILURE,
    SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitSystemConfigType(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_BEGIN,
      });
  
      let apiurl = '/api/b/systemConfigType/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/systemConfigType/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitSystemConfigTypeError() {
    return {
      type: SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitSystemConfigTypePending: true,
          submitSystemConfigTypeError: null,
        };
  
      case SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_SUCCESS:
        // The request is success
        return {
          ...state,
          submitSystemConfigTypePending: false,
          submitSystemConfigTypeError: null,
        };
  
      case SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_FAILURE:
        // The request is failed
        return {
          ...state,
          submitSystemConfigTypePending: false,
          submitSystemConfigTypeError: action.data.error,
        };
  
      case SYSTEMCONFIG_SUBMIT_SYSTEMCONFIGTYPE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitSystemConfigTypeError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/submitSystemConfigType.js